import { shouldRedirectToNotFound, useCoreConfig } from "@ob/core";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { Layout } from "../components";

const Root = () => {
  const { pathname } = useLocation();
  const { defaultPath, allowedPaths } = useCoreConfig();
  const url = new URL(window.location.href);
  const searchParams = url.searchParams.toString();
  const shouldRedirect = shouldRedirectToNotFound(pathname, allowedPaths);
  if (shouldRedirect) {
    return (
      <Navigate
        to={`${defaultPath}${searchParams ? `?${searchParams}` : ""}`}
      />
    );
  }
  return (
    <Layout>
      <Outlet />
    </Layout>
  );
};

export { Root };
export default Root;
